/**
 * INSTRUMENT CATALOG - Code-Owned Source File
 * 
 * This file contains the complete instrument catalog with 20-25 years of historical data.
 * Loaded in-memory at runtime. Changes require Git commit and deployment.
 * 
 * DO NOT EDIT MANUALLY - Use Admin Authoring Tool at /admin/instruments
 * 
 * Version: 3
 * Last Updated: 2026-02-09
 */

export const CATALOG_VERSION = 3;

export const INSTRUMENT_CATALOG = [
    {
        "id": "chspi",
        "name": "iShares Core SPI® ETF (CH)",
        "assetClass": "Equities",
        "quotationCurrency": "CHF",
        "timeSeries": [
            {
                "date": "2015-01-31",
                "value": 73.66
            },
            {
                "date": "2015-02-28",
                "value": 79.4
            },
            {
                "date": "2015-03-31",
                "value": 81.35
            },
            {
                "date": "2015-04-30",
                "value": 81.73
            },
            {
                "date": "2015-05-31",
                "value": 83.39
            },
            {
                "date": "2015-06-30",
                "value": 79.35
            },
            {
                "date": "2015-07-31",
                "value": 85.09
            },
            {
                "date": "2015-08-31",
                "value": 79.38
            },
            {
                "date": "2015-09-30",
                "value": 77.07
            },
            {
                "date": "2015-10-31",
                "value": 81.09
            },
            {
                "date": "2015-11-30",
                "value": 82.02
            },
            {
                "date": "2015-12-31",
                "value": 81.1
            },
            {
                "date": "2016-01-31",
                "value": 76.13
            },
            {
                "date": "2016-02-29",
                "value": 73.15
            },
            {
                "date": "2016-03-31",
                "value": 73.77
            },
            {
                "date": "2016-04-30",
                "value": 75.96
            },
            {
                "date": "2016-05-31",
                "value": 78.61
            },
            {
                "date": "2016-06-30",
                "value": 76.79
            },
            {
                "date": "2016-07-31",
                "value": 78.38
            },
            {
                "date": "2016-08-31",
                "value": 78.91
            },
            {
                "date": "2016-09-30",
                "value": 78.37
            },
            {
                "date": "2016-10-31",
                "value": 76.2
            },
            {
                "date": "2016-11-30",
                "value": 76.58
            },
            {
                "date": "2016-12-31",
                "value": 79.85
            },
            {
                "date": "2017-01-31",
                "value": 80.35
            },
            {
                "date": "2017-02-28",
                "value": 82.79
            },
            {
                "date": "2017-03-31",
                "value": 85.37
            },
            {
                "date": "2017-04-30",
                "value": 88.16
            },
            {
                "date": "2017-05-31",
                "value": 91.05
            },
            {
                "date": "2017-06-30",
                "value": 89.7
            },
            {
                "date": "2017-07-31",
                "value": 91.03
            },
            {
                "date": "2017-08-31",
                "value": 90.07
            },
            {
                "date": "2017-09-30",
                "value": 92.43
            },
            {
                "date": "2017-10-31",
                "value": 93.9
            },
            {
                "date": "2017-11-30",
                "value": 94.56
            },
            {
                "date": "2017-12-31",
                "value": 95.02
            },
            {
                "date": "2018-01-31",
                "value": 94.99
            },
            {
                "date": "2018-02-28",
                "value": 90.78
            },
            {
                "date": "2018-03-31",
                "value": 90.23
            },
            {
                "date": "2018-04-30",
                "value": 92.71
            },
            {
                "date": "2018-05-31",
                "value": 89.31
            },
            {
                "date": "2018-06-30",
                "value": 90.65
            },
            {
                "date": "2018-07-31",
                "value": 95.86
            },
            {
                "date": "2018-08-31",
                "value": 94.48
            },
            {
                "date": "2018-09-30",
                "value": 94.99
            },
            {
                "date": "2018-10-31",
                "value": 93.48
            },
            {
                "date": "2018-11-30",
                "value": 92.64
            },
            {
                "date": "2018-12-31",
                "value": 86.11
            },
            {
                "date": "2019-01-31",
                "value": 92.43
            },
            {
                "date": "2019-02-28",
                "value": 96.64
            },
            {
                "date": "2019-03-31",
                "value": 98.78
            },
            {
                "date": "2019-04-30",
                "value": 103.22
            },
            {
                "date": "2019-05-31",
                "value": 101.29
            },
            {
                "date": "2019-06-30",
                "value": 105.19
            },
            {
                "date": "2019-07-31",
                "value": 106.19
            },
            {
                "date": "2019-08-31",
                "value": 105.84
            },
            {
                "date": "2019-09-30",
                "value": 107.39
            },
            {
                "date": "2019-10-31",
                "value": 108.03
            },
            {
                "date": "2019-11-30",
                "value": 111.26
            },
            {
                "date": "2019-12-31",
                "value": 112.31
            },
            {
                "date": "2020-01-31",
                "value": 113.12
            },
            {
                "date": "2020-02-29",
                "value": 104.89
            },
            {
                "date": "2020-03-31",
                "value": 99.63
            },
            {
                "date": "2020-04-30",
                "value": 104.8
            },
            {
                "date": "2020-05-31",
                "value": 107.26
            },
            {
                "date": "2020-06-30",
                "value": 109.14
            },
            {
                "date": "2020-07-31",
                "value": 108.46
            },
            {
                "date": "2020-08-31",
                "value": 111.25
            },
            {
                "date": "2020-09-30",
                "value": 111.33
            },
            {
                "date": "2020-10-31",
                "value": 105.05
            },
            {
                "date": "2020-11-30",
                "value": 113.58
            },
            {
                "date": "2020-12-31",
                "value": 116.88
            },
            {
                "date": "2021-01-31",
                "value": 115.4
            },
            {
                "date": "2021-02-28",
                "value": 115.3
            },
            {
                "date": "2021-03-31",
                "value": 122.82
            },
            {
                "date": "2021-04-30",
                "value": 124.06
            },
            {
                "date": "2021-05-31",
                "value": 128.46
            },
            {
                "date": "2021-06-30",
                "value": 134.66
            },
            {
                "date": "2021-07-31",
                "value": 136.59
            },
            {
                "date": "2021-08-31",
                "value": 139.75
            },
            {
                "date": "2021-09-30",
                "value": 131.59
            },
            {
                "date": "2021-10-31",
                "value": 136.69
            },
            {
                "date": "2021-11-30",
                "value": 136.07
            },
            {
                "date": "2021-12-31",
                "value": 144.16
            },
            {
                "date": "2022-01-31",
                "value": 136.05
            },
            {
                "date": "2022-02-28",
                "value": 132.94
            },
            {
                "date": "2022-03-31",
                "value": 135.93
            },
            {
                "date": "2022-04-30",
                "value": 136.85
            },
            {
                "date": "2022-05-31",
                "value": 130.95
            },
            {
                "date": "2022-06-30",
                "value": 121.28
            },
            {
                "date": "2022-07-31",
                "value": 126.21
            },
            {
                "date": "2022-08-31",
                "value": 122.58
            },
            {
                "date": "2022-09-30",
                "value": 115.33
            },
            {
                "date": "2022-10-31",
                "value": 120.73
            },
            {
                "date": "2022-11-30",
                "value": 124.14
            },
            {
                "date": "2022-12-31",
                "value": 120.42
            },
            {
                "date": "2023-01-31",
                "value": 126.89
            },
            {
                "date": "2023-02-28",
                "value": 125.08
            },
            {
                "date": "2023-03-31",
                "value": 127.32
            },
            {
                "date": "2023-04-30",
                "value": 131.99
            },
            {
                "date": "2023-05-31",
                "value": 130
            },
            {
                "date": "2023-06-30",
                "value": 130.19
            },
            {
                "date": "2023-07-31",
                "value": 130.7
            },
            {
                "date": "2023-08-31",
                "value": 128.25
            },
            {
                "date": "2023-09-30",
                "value": 125.91
            },
            {
                "date": "2023-10-31",
                "value": 119.03
            },
            {
                "date": "2023-11-30",
                "value": 124.42
            },
            {
                "date": "2023-12-31",
                "value": 127.61
            },
            {
                "date": "2024-01-31",
                "value": 129.23
            },
            {
                "date": "2024-02-29",
                "value": 129.94
            },
            {
                "date": "2024-03-31",
                "value": 134.89
            },
            {
                "date": "2024-04-30",
                "value": 132.25
            },
            {
                "date": "2024-05-31",
                "value": 139.8
            },
            {
                "date": "2024-06-30",
                "value": 139.26
            },
            {
                "date": "2024-07-31",
                "value": 142.95
            },
            {
                "date": "2024-08-31",
                "value": 144.27
            },
            {
                "date": "2024-09-30",
                "value": 141.88
            },
            {
                "date": "2024-10-31",
                "value": 137.4
            },
            {
                "date": "2024-11-30",
                "value": 136.99
            },
            {
                "date": "2024-12-31",
                "value": 134.91
            },
            {
                "date": "2025-01-31",
                "value": 146.25
            },
            {
                "date": "2025-02-28",
                "value": 149.89
            },
            {
                "date": "2025-03-31",
                "value": 146.81
            },
            {
                "date": "2025-04-30",
                "value": 143.96
            },
            {
                "date": "2025-05-31",
                "value": 147.01
            },
            {
                "date": "2025-06-30",
                "value": 144.24
            },
            {
                "date": "2025-07-31",
                "value": 144.22
            },
            {
                "date": "2025-08-31",
                "value": 147.46
            },
            {
                "date": "2025-09-30",
                "value": 146.1
            },
            {
                "date": "2025-10-31",
                "value": 148.22
            },
            {
                "date": "2025-11-30",
                "value": 154.08
            },
            {
                "date": "2025-12-31",
                "value": 159.02
            },
            {
                "date": "2026-01-31",
                "value": 159.1
            },
            {
                "date": "2026-02-28",
                "value": 161.24
            }
        ],
        "frequency": "monthly",
        "active": true
    },
    {
        "id": "chcorp",
        "name": "iShares Core CHF Corporate Bond ETF",
        "assetClass": "Bonds",
        "quotationCurrency": "CHF",
        "timeSeries": [
            {
                "date": "2005-01-31",
                "value": 96.32
            },
            {
                "date": "2005-02-28",
                "value": 97.81
            },
            {
                "date": "2005-03-31",
                "value": 97.97
            },
            {
                "date": "2005-04-30",
                "value": 97.32
            },
            {
                "date": "2005-05-31",
                "value": 96.36
            },
            {
                "date": "2005-06-30",
                "value": 96.48
            },
            {
                "date": "2005-07-31",
                "value": 95.59
            },
            {
                "date": "2005-08-31",
                "value": 94.32
            },
            {
                "date": "2005-09-30",
                "value": 94.6
            },
            {
                "date": "2005-10-31",
                "value": 94.82
            },
            {
                "date": "2005-11-30",
                "value": 95.43
            },
            {
                "date": "2005-12-31",
                "value": 94.66
            },
            {
                "date": "2006-01-31",
                "value": 94.75
            },
            {
                "date": "2006-02-28",
                "value": 94.79
            },
            {
                "date": "2006-03-31",
                "value": 93.46
            },
            {
                "date": "2006-04-30",
                "value": 94.05
            },
            {
                "date": "2006-05-31",
                "value": 94.45
            },
            {
                "date": "2006-06-30",
                "value": 96.8
            },
            {
                "date": "2006-07-31",
                "value": 97.09
            },
            {
                "date": "2006-08-31",
                "value": 97.05
            },
            {
                "date": "2006-09-30",
                "value": 98.34
            },
            {
                "date": "2006-10-31",
                "value": 98.64
            },
            {
                "date": "2006-11-30",
                "value": 99.63
            },
            {
                "date": "2006-12-31",
                "value": 99.37
            },
            {
                "date": "2007-01-31",
                "value": 99.68
            },
            {
                "date": "2007-02-28",
                "value": 100.8
            },
            {
                "date": "2007-03-31",
                "value": 101.61
            },
            {
                "date": "2007-04-30",
                "value": 101.84
            },
            {
                "date": "2007-05-31",
                "value": 100.84
            },
            {
                "date": "2007-06-30",
                "value": 101.39
            },
            {
                "date": "2007-07-31",
                "value": 101.57
            },
            {
                "date": "2007-08-31",
                "value": 102.4
            },
            {
                "date": "2007-09-30",
                "value": 102.72
            },
            {
                "date": "2007-10-31",
                "value": 103.94
            },
            {
                "date": "2007-11-30",
                "value": 103.99
            },
            {
                "date": "2007-12-31",
                "value": 104.31
            },
            {
                "date": "2008-01-31",
                "value": 105.11
            },
            {
                "date": "2008-02-29",
                "value": 104.07
            },
            {
                "date": "2008-03-31",
                "value": 103.76
            },
            {
                "date": "2008-04-30",
                "value": 103.34
            },
            {
                "date": "2008-05-31",
                "value": 105.49
            },
            {
                "date": "2008-06-30",
                "value": 105.5
            },
            {
                "date": "2008-07-31",
                "value": 106.29
            },
            {
                "date": "2008-08-31",
                "value": 107.06
            },
            {
                "date": "2008-09-30",
                "value": 106.86
            },
            {
                "date": "2008-10-31",
                "value": 105.31
            },
            {
                "date": "2008-11-30",
                "value": 106.44
            },
            {
                "date": "2008-12-31",
                "value": 106.11
            },
            {
                "date": "2009-01-31",
                "value": 106.98
            },
            {
                "date": "2009-02-28",
                "value": 105.69
            },
            {
                "date": "2009-03-31",
                "value": 105.33
            },
            {
                "date": "2009-04-30",
                "value": 106.76
            },
            {
                "date": "2009-05-31",
                "value": 108.39
            },
            {
                "date": "2009-06-30",
                "value": 107.09
            },
            {
                "date": "2009-07-31",
                "value": 105.77
            },
            {
                "date": "2009-08-31",
                "value": 105.83
            },
            {
                "date": "2009-09-30",
                "value": 106.71
            },
            {
                "date": "2009-10-31",
                "value": 106.98
            },
            {
                "date": "2009-11-30",
                "value": 107.42
            },
            {
                "date": "2009-12-31",
                "value": 106.46
            },
            {
                "date": "2010-01-31",
                "value": 107.19
            },
            {
                "date": "2010-02-28",
                "value": 108.5
            },
            {
                "date": "2010-03-31",
                "value": 108.13
            },
            {
                "date": "2010-04-30",
                "value": 106.69
            },
            {
                "date": "2010-05-31",
                "value": 105.99
            },
            {
                "date": "2010-06-30",
                "value": 106.9
            },
            {
                "date": "2010-07-31",
                "value": 105.15
            },
            {
                "date": "2010-08-31",
                "value": 105.16
            },
            {
                "date": "2010-09-30",
                "value": 104.23
            },
            {
                "date": "2010-10-31",
                "value": 104.19
            },
            {
                "date": "2010-11-30",
                "value": 104.04
            },
            {
                "date": "2010-12-31",
                "value": 104.16
            },
            {
                "date": "2011-01-31",
                "value": 105.83
            },
            {
                "date": "2011-02-28",
                "value": 106.38
            },
            {
                "date": "2011-03-31",
                "value": 107.91
            },
            {
                "date": "2011-04-30",
                "value": 107.86
            },
            {
                "date": "2011-05-31",
                "value": 107.45
            },
            {
                "date": "2011-06-30",
                "value": 107.97
            },
            {
                "date": "2011-07-31",
                "value": 105.01
            },
            {
                "date": "2011-08-31",
                "value": 105.08
            },
            {
                "date": "2011-09-30",
                "value": 105.35
            },
            {
                "date": "2011-10-31",
                "value": 104.15
            },
            {
                "date": "2011-11-30",
                "value": 104.74
            },
            {
                "date": "2011-12-31",
                "value": 104.26
            },
            {
                "date": "2012-01-31",
                "value": 101.8
            },
            {
                "date": "2012-02-29",
                "value": 101.69
            },
            {
                "date": "2012-03-31",
                "value": 100.79
            },
            {
                "date": "2012-04-30",
                "value": 100.37
            },
            {
                "date": "2012-05-31",
                "value": 100.32
            },
            {
                "date": "2012-06-30",
                "value": 101.67
            },
            {
                "date": "2012-07-31",
                "value": 101.88
            },
            {
                "date": "2012-08-31",
                "value": 101.95
            },
            {
                "date": "2012-09-30",
                "value": 102.45
            },
            {
                "date": "2012-10-31",
                "value": 100.7
            },
            {
                "date": "2012-11-30",
                "value": 102.04
            },
            {
                "date": "2012-12-31",
                "value": 101.05
            },
            {
                "date": "2013-01-31",
                "value": 101.59
            },
            {
                "date": "2013-02-28",
                "value": 100.55
            },
            {
                "date": "2013-03-31",
                "value": 99.67
            },
            {
                "date": "2013-04-30",
                "value": 99.37
            },
            {
                "date": "2013-05-31",
                "value": 101.36
            },
            {
                "date": "2013-06-30",
                "value": 102.16
            },
            {
                "date": "2013-07-31",
                "value": 101.65
            },
            {
                "date": "2013-08-31",
                "value": 101.46
            },
            {
                "date": "2013-09-30",
                "value": 100.39
            },
            {
                "date": "2013-10-31",
                "value": 100.46
            },
            {
                "date": "2013-11-30",
                "value": 99.99
            },
            {
                "date": "2013-12-31",
                "value": 100.81
            },
            {
                "date": "2014-01-31",
                "value": 99.54
            },
            {
                "date": "2014-02-28",
                "value": 99.31
            },
            {
                "date": "2014-03-31",
                "value": 98.57
            },
            {
                "date": "2014-04-30",
                "value": 97.96
            },
            {
                "date": "2014-05-31",
                "value": 98.75
            },
            {
                "date": "2014-06-30",
                "value": 98.98
            },
            {
                "date": "2014-07-31",
                "value": 99.66
            },
            {
                "date": "2014-08-31",
                "value": 100.94
            },
            {
                "date": "2014-09-30",
                "value": 102.2
            },
            {
                "date": "2014-10-31",
                "value": 100.9
            },
            {
                "date": "2014-11-30",
                "value": 101.55
            },
            {
                "date": "2014-12-31",
                "value": 99.86
            },
            {
                "date": "2015-01-31",
                "value": 99.89
            },
            {
                "date": "2015-02-28",
                "value": 101.91
            },
            {
                "date": "2015-03-31",
                "value": 101.82
            },
            {
                "date": "2015-04-30",
                "value": 101.54
            },
            {
                "date": "2015-05-31",
                "value": 101.82
            },
            {
                "date": "2015-06-30",
                "value": 101.94
            },
            {
                "date": "2015-07-31",
                "value": 102.07
            },
            {
                "date": "2015-08-31",
                "value": 101.39
            },
            {
                "date": "2015-09-30",
                "value": 102.59
            },
            {
                "date": "2015-10-31",
                "value": 103.61
            },
            {
                "date": "2015-11-30",
                "value": 103.49
            },
            {
                "date": "2015-12-31",
                "value": 103.92
            },
            {
                "date": "2016-01-31",
                "value": 104.71
            },
            {
                "date": "2016-02-29",
                "value": 105.89
            },
            {
                "date": "2016-03-31",
                "value": 106.42
            },
            {
                "date": "2016-04-30",
                "value": 107.26
            },
            {
                "date": "2016-05-31",
                "value": 107.09
            },
            {
                "date": "2016-06-30",
                "value": 106.05
            },
            {
                "date": "2016-07-31",
                "value": 105.63
            },
            {
                "date": "2016-08-31",
                "value": 106.81
            },
            {
                "date": "2016-09-30",
                "value": 107.96
            },
            {
                "date": "2016-10-31",
                "value": 108.23
            },
            {
                "date": "2016-11-30",
                "value": 107.72
            },
            {
                "date": "2016-12-31",
                "value": 108.16
            },
            {
                "date": "2017-01-31",
                "value": 110.07
            },
            {
                "date": "2017-02-28",
                "value": 111.67
            },
            {
                "date": "2017-03-31",
                "value": 111.02
            },
            {
                "date": "2017-04-30",
                "value": 111.08
            },
            {
                "date": "2017-05-31",
                "value": 109.58
            },
            {
                "date": "2017-06-30",
                "value": 108.45
            },
            {
                "date": "2017-07-31",
                "value": 108.76
            },
            {
                "date": "2017-08-31",
                "value": 108.89
            },
            {
                "date": "2017-09-30",
                "value": 110.05
            },
            {
                "date": "2017-10-31",
                "value": 111.56
            },
            {
                "date": "2017-11-30",
                "value": 112.6
            },
            {
                "date": "2017-12-31",
                "value": 114.2
            },
            {
                "date": "2018-01-31",
                "value": 113.69
            },
            {
                "date": "2018-02-28",
                "value": 112.52
            },
            {
                "date": "2018-03-31",
                "value": 113.2
            },
            {
                "date": "2018-04-30",
                "value": 116.34
            },
            {
                "date": "2018-05-31",
                "value": 116.87
            },
            {
                "date": "2018-06-30",
                "value": 115.64
            },
            {
                "date": "2018-07-31",
                "value": 116.04
            },
            {
                "date": "2018-08-31",
                "value": 117.81
            },
            {
                "date": "2018-09-30",
                "value": 116.71
            },
            {
                "date": "2018-10-31",
                "value": 117.76
            },
            {
                "date": "2018-11-30",
                "value": 117.16
            },
            {
                "date": "2018-12-31",
                "value": 118.77
            },
            {
                "date": "2019-01-31",
                "value": 119.82
            },
            {
                "date": "2019-02-28",
                "value": 120.3
            },
            {
                "date": "2019-03-31",
                "value": 122.83
            },
            {
                "date": "2019-04-30",
                "value": 122.45
            },
            {
                "date": "2019-05-31",
                "value": 121.73
            },
            {
                "date": "2019-06-30",
                "value": 124.11
            },
            {
                "date": "2019-07-31",
                "value": 123.15
            },
            {
                "date": "2019-08-31",
                "value": 125.98
            },
            {
                "date": "2019-09-30",
                "value": 126.06
            },
            {
                "date": "2019-10-31",
                "value": 124.88
            },
            {
                "date": "2019-11-30",
                "value": 125
            },
            {
                "date": "2019-12-31",
                "value": 125.29
            },
            {
                "date": "2020-01-31",
                "value": 125.66
            },
            {
                "date": "2020-02-29",
                "value": 125.55
            },
            {
                "date": "2020-03-31",
                "value": 127.03
            },
            {
                "date": "2020-04-30",
                "value": 124.21
            },
            {
                "date": "2020-05-31",
                "value": 123.65
            },
            {
                "date": "2020-06-30",
                "value": 123.45
            },
            {
                "date": "2020-07-31",
                "value": 125.82
            },
            {
                "date": "2020-08-31",
                "value": 123.43
            },
            {
                "date": "2020-09-30",
                "value": 123.14
            },
            {
                "date": "2020-10-31",
                "value": 121.85
            },
            {
                "date": "2020-11-30",
                "value": 121.17
            },
            {
                "date": "2020-12-31",
                "value": 122.06
            },
            {
                "date": "2021-01-31",
                "value": 122.69
            },
            {
                "date": "2021-02-28",
                "value": 124.58
            },
            {
                "date": "2021-03-31",
                "value": 123.95
            },
            {
                "date": "2021-04-30",
                "value": 124.41
            },
            {
                "date": "2021-05-31",
                "value": 126
            },
            {
                "date": "2021-06-30",
                "value": 127.26
            },
            {
                "date": "2021-07-31",
                "value": 126.96
            },
            {
                "date": "2021-08-31",
                "value": 128.52
            },
            {
                "date": "2021-09-30",
                "value": 127.46
            },
            {
                "date": "2021-10-31",
                "value": 129.89
            },
            {
                "date": "2021-11-30",
                "value": 130.22
            },
            {
                "date": "2021-12-31",
                "value": 130.2
            },
            {
                "date": "2022-01-31",
                "value": 130.68
            },
            {
                "date": "2022-02-28",
                "value": 131.92
            },
            {
                "date": "2022-03-31",
                "value": 134.35
            },
            {
                "date": "2022-04-30",
                "value": 134.3
            },
            {
                "date": "2022-05-31",
                "value": 133.94
            },
            {
                "date": "2022-06-30",
                "value": 134.86
            },
            {
                "date": "2022-07-31",
                "value": 133.82
            },
            {
                "date": "2022-08-31",
                "value": 131.68
            },
            {
                "date": "2022-09-30",
                "value": 132.91
            },
            {
                "date": "2022-10-31",
                "value": 132.54
            },
            {
                "date": "2022-11-30",
                "value": 134.17
            },
            {
                "date": "2022-12-31",
                "value": 132.92
            },
            {
                "date": "2023-01-31",
                "value": 129.21
            },
            {
                "date": "2023-02-28",
                "value": 129.7
            },
            {
                "date": "2023-03-31",
                "value": 130.03
            },
            {
                "date": "2023-04-30",
                "value": 132.24
            },
            {
                "date": "2023-05-31",
                "value": 133.07
            },
            {
                "date": "2023-06-30",
                "value": 133.61
            },
            {
                "date": "2023-07-31",
                "value": 134.53
            },
            {
                "date": "2023-08-31",
                "value": 134.17
            },
            {
                "date": "2023-09-30",
                "value": 134.41
            },
            {
                "date": "2023-10-31",
                "value": 132.73
            },
            {
                "date": "2023-11-30",
                "value": 133.55
            },
            {
                "date": "2023-12-31",
                "value": 132.61
            },
            {
                "date": "2024-01-31",
                "value": 132.15
            },
            {
                "date": "2024-02-29",
                "value": 133.21
            },
            {
                "date": "2024-03-31",
                "value": 134.56
            },
            {
                "date": "2024-04-30",
                "value": 133.34
            },
            {
                "date": "2024-05-31",
                "value": 136.14
            },
            {
                "date": "2024-06-30",
                "value": 135.47
            },
            {
                "date": "2024-07-31",
                "value": 136.74
            },
            {
                "date": "2024-08-31",
                "value": 138.18
            },
            {
                "date": "2024-09-30",
                "value": 138.63
            },
            {
                "date": "2024-10-31",
                "value": 139
            },
            {
                "date": "2024-11-30",
                "value": 141.64
            },
            {
                "date": "2024-12-31",
                "value": 143.04
            }
        ],
        "frequency": "monthly",
        "active": true
    },
    {
        "id": "UBS_SXI_REALESTATE_CHF",
        "name": "UBS ETF (CH) SXI Real Estate (CHF) A-dis",
        "assetClass": "Real Estate",
        "quotationCurrency": "CHF",
        "timeSeries": [
            {
                "date": "2000-01-31",
                "value": 80.05
            },
            {
                "date": "2000-02-29",
                "value": 80.05
            },
            {
                "date": "2000-03-31",
                "value": 80.15
            },
            {
                "date": "2000-04-30",
                "value": 81.56
            },
            {
                "date": "2000-05-31",
                "value": 81.64
            },
            {
                "date": "2000-06-30",
                "value": 79.48
            },
            {
                "date": "2000-07-31",
                "value": 80.29
            },
            {
                "date": "2000-08-31",
                "value": 80.14
            },
            {
                "date": "2000-09-30",
                "value": 80.07
            },
            {
                "date": "2000-10-31",
                "value": 80.54
            },
            {
                "date": "2000-11-30",
                "value": 81.19
            },
            {
                "date": "2000-12-31",
                "value": 83.37
            },
            {
                "date": "2001-01-31",
                "value": 84.75
            },
            {
                "date": "2001-02-28",
                "value": 85.24
            },
            {
                "date": "2001-03-31",
                "value": 84.28
            },
            {
                "date": "2001-04-30",
                "value": 82.86
            },
            {
                "date": "2001-05-31",
                "value": 83.56
            },
            {
                "date": "2001-06-30",
                "value": 86.04
            },
            {
                "date": "2001-07-31",
                "value": 86.41
            },
            {
                "date": "2001-08-31",
                "value": 86.53
            },
            {
                "date": "2001-09-30",
                "value": 87.76
            },
            {
                "date": "2001-10-31",
                "value": 85.51
            },
            {
                "date": "2001-11-30",
                "value": 85.28
            },
            {
                "date": "2001-12-31",
                "value": 86.41
            },
            {
                "date": "2002-01-31",
                "value": 88.22
            },
            {
                "date": "2002-02-28",
                "value": 88.11
            },
            {
                "date": "2002-03-31",
                "value": 89.08
            },
            {
                "date": "2002-04-30",
                "value": 89.83
            },
            {
                "date": "2002-05-31",
                "value": 91.55
            },
            {
                "date": "2002-06-30",
                "value": 89.84
            },
            {
                "date": "2002-07-31",
                "value": 91.17
            },
            {
                "date": "2002-08-31",
                "value": 88.73
            },
            {
                "date": "2002-09-30",
                "value": 84.39
            },
            {
                "date": "2002-10-31",
                "value": 83.66
            },
            {
                "date": "2002-11-30",
                "value": 82.42
            },
            {
                "date": "2002-12-31",
                "value": 84.16
            },
            {
                "date": "2003-01-31",
                "value": 85.57
            },
            {
                "date": "2003-02-28",
                "value": 83.78
            },
            {
                "date": "2003-03-31",
                "value": 85.49
            },
            {
                "date": "2003-04-30",
                "value": 84.08
            },
            {
                "date": "2003-05-31",
                "value": 84.23
            },
            {
                "date": "2003-06-30",
                "value": 84.03
            },
            {
                "date": "2003-07-31",
                "value": 84.51
            },
            {
                "date": "2003-08-31",
                "value": 86.19
            },
            {
                "date": "2003-09-30",
                "value": 87.6
            },
            {
                "date": "2003-10-31",
                "value": 88.52
            },
            {
                "date": "2003-11-30",
                "value": 89.98
            },
            {
                "date": "2003-12-31",
                "value": 91.15
            },
            {
                "date": "2004-01-31",
                "value": 90.33
            },
            {
                "date": "2004-02-29",
                "value": 89.35
            },
            {
                "date": "2004-03-31",
                "value": 88.82
            },
            {
                "date": "2004-04-30",
                "value": 90.02
            },
            {
                "date": "2004-05-31",
                "value": 89.88
            },
            {
                "date": "2004-06-30",
                "value": 94.4
            },
            {
                "date": "2004-07-31",
                "value": 93.18
            },
            {
                "date": "2004-08-31",
                "value": 91.46
            },
            {
                "date": "2004-09-30",
                "value": 93.19
            },
            {
                "date": "2004-10-31",
                "value": 96.16
            },
            {
                "date": "2004-11-30",
                "value": 97.47
            },
            {
                "date": "2004-12-31",
                "value": 99.44
            },
            {
                "date": "2005-01-31",
                "value": 102.63
            },
            {
                "date": "2005-02-28",
                "value": 102.79
            },
            {
                "date": "2005-03-31",
                "value": 100.23
            },
            {
                "date": "2005-04-30",
                "value": 99.51
            },
            {
                "date": "2005-05-31",
                "value": 101.76
            },
            {
                "date": "2005-06-30",
                "value": 99.17
            },
            {
                "date": "2005-07-31",
                "value": 99.59
            },
            {
                "date": "2005-08-31",
                "value": 100.44
            },
            {
                "date": "2005-09-30",
                "value": 100.16
            },
            {
                "date": "2005-10-31",
                "value": 101.96
            },
            {
                "date": "2005-11-30",
                "value": 103.5
            },
            {
                "date": "2005-12-31",
                "value": 108.67
            },
            {
                "date": "2006-01-31",
                "value": 110.39
            },
            {
                "date": "2006-02-28",
                "value": 109.44
            },
            {
                "date": "2006-03-31",
                "value": 108.59
            },
            {
                "date": "2006-04-30",
                "value": 107.16
            },
            {
                "date": "2006-05-31",
                "value": 109.58
            },
            {
                "date": "2006-06-30",
                "value": 108.72
            },
            {
                "date": "2006-07-31",
                "value": 108.95
            },
            {
                "date": "2006-08-31",
                "value": 110.96
            },
            {
                "date": "2006-09-30",
                "value": 109.74
            },
            {
                "date": "2006-10-31",
                "value": 109.48
            },
            {
                "date": "2006-11-30",
                "value": 105.84
            },
            {
                "date": "2006-12-31",
                "value": 103.91
            },
            {
                "date": "2007-01-31",
                "value": 103.1
            },
            {
                "date": "2007-02-28",
                "value": 104.32
            },
            {
                "date": "2007-03-31",
                "value": 107.17
            },
            {
                "date": "2007-04-30",
                "value": 107.51
            },
            {
                "date": "2007-05-31",
                "value": 108.45
            },
            {
                "date": "2007-06-30",
                "value": 109.19
            },
            {
                "date": "2007-07-31",
                "value": 111.94
            },
            {
                "date": "2007-08-31",
                "value": 114.33
            },
            {
                "date": "2007-09-30",
                "value": 115.36
            },
            {
                "date": "2007-10-31",
                "value": 113.43
            },
            {
                "date": "2007-11-30",
                "value": 115.88
            },
            {
                "date": "2007-12-31",
                "value": 117.16
            },
            {
                "date": "2008-01-31",
                "value": 120.45
            },
            {
                "date": "2008-02-29",
                "value": 120.8
            },
            {
                "date": "2008-03-31",
                "value": 125.94
            },
            {
                "date": "2008-04-30",
                "value": 125.48
            },
            {
                "date": "2008-05-31",
                "value": 126.32
            },
            {
                "date": "2008-06-30",
                "value": 121.37
            },
            {
                "date": "2008-07-31",
                "value": 123.24
            },
            {
                "date": "2008-08-31",
                "value": 124.53
            },
            {
                "date": "2008-09-30",
                "value": 121.91
            },
            {
                "date": "2008-10-31",
                "value": 119.84
            },
            {
                "date": "2008-11-30",
                "value": 117.71
            },
            {
                "date": "2008-12-31",
                "value": 115.9
            },
            {
                "date": "2009-01-31",
                "value": 117.23
            },
            {
                "date": "2009-02-28",
                "value": 114.5
            },
            {
                "date": "2009-03-31",
                "value": 110.46
            },
            {
                "date": "2009-04-30",
                "value": 111.33
            },
            {
                "date": "2009-05-31",
                "value": 109.03
            },
            {
                "date": "2009-06-30",
                "value": 111.34
            },
            {
                "date": "2009-07-31",
                "value": 111.73
            },
            {
                "date": "2009-08-31",
                "value": 117.23
            },
            {
                "date": "2009-09-30",
                "value": 118.3
            },
            {
                "date": "2009-10-31",
                "value": 121.94
            },
            {
                "date": "2009-11-30",
                "value": 119.19
            },
            {
                "date": "2009-12-31",
                "value": 119.32
            },
            {
                "date": "2010-01-31",
                "value": 120.5
            },
            {
                "date": "2010-02-28",
                "value": 125.13
            },
            {
                "date": "2010-03-31",
                "value": 121.36
            },
            {
                "date": "2010-04-30",
                "value": 124.19
            },
            {
                "date": "2010-05-31",
                "value": 126.1
            },
            {
                "date": "2010-06-30",
                "value": 130.41
            },
            {
                "date": "2010-07-31",
                "value": 132.72
            },
            {
                "date": "2010-08-31",
                "value": 133.32
            },
            {
                "date": "2010-09-30",
                "value": 132.4
            },
            {
                "date": "2010-10-31",
                "value": 129.56
            },
            {
                "date": "2010-11-30",
                "value": 130.52
            },
            {
                "date": "2010-12-31",
                "value": 130.47
            },
            {
                "date": "2011-01-31",
                "value": 136.2
            },
            {
                "date": "2011-02-28",
                "value": 135.01
            },
            {
                "date": "2011-03-31",
                "value": 136.35
            },
            {
                "date": "2011-04-30",
                "value": 132.55
            },
            {
                "date": "2011-05-31",
                "value": 131.97
            },
            {
                "date": "2011-06-30",
                "value": 133.12
            },
            {
                "date": "2011-07-31",
                "value": 135.78
            },
            {
                "date": "2011-08-31",
                "value": 140.18
            },
            {
                "date": "2011-09-30",
                "value": 140.55
            },
            {
                "date": "2011-10-31",
                "value": 137.9
            },
            {
                "date": "2011-11-30",
                "value": 139.65
            },
            {
                "date": "2011-12-31",
                "value": 141.58
            },
            {
                "date": "2012-01-31",
                "value": 143.47
            },
            {
                "date": "2012-02-29",
                "value": 141.96
            },
            {
                "date": "2012-03-31",
                "value": 145.68
            },
            {
                "date": "2012-04-30",
                "value": 146.44
            },
            {
                "date": "2012-05-31",
                "value": 149
            },
            {
                "date": "2012-06-30",
                "value": 153.32
            },
            {
                "date": "2012-07-31",
                "value": 155.73
            },
            {
                "date": "2012-08-31",
                "value": 157.17
            },
            {
                "date": "2012-09-30",
                "value": 164.48
            },
            {
                "date": "2012-10-31",
                "value": 165.86
            },
            {
                "date": "2012-11-30",
                "value": 165.46
            },
            {
                "date": "2012-12-31",
                "value": 166.41
            },
            {
                "date": "2013-01-31",
                "value": 171.93
            },
            {
                "date": "2013-02-28",
                "value": 172.94
            },
            {
                "date": "2013-03-31",
                "value": 175.34
            },
            {
                "date": "2013-04-30",
                "value": 180.14
            },
            {
                "date": "2013-05-31",
                "value": 178.93
            },
            {
                "date": "2013-06-30",
                "value": 173.37
            },
            {
                "date": "2013-07-31",
                "value": 175.02
            },
            {
                "date": "2013-08-31",
                "value": 176.44
            },
            {
                "date": "2013-09-30",
                "value": 174.91
            },
            {
                "date": "2013-10-31",
                "value": 178.57
            },
            {
                "date": "2013-11-30",
                "value": 181.36
            },
            {
                "date": "2013-12-31",
                "value": 178.39
            },
            {
                "date": "2014-01-31",
                "value": 180.86
            },
            {
                "date": "2014-02-28",
                "value": 180.78
            },
            {
                "date": "2014-03-31",
                "value": 176.06
            },
            {
                "date": "2014-04-30",
                "value": 178.27
            },
            {
                "date": "2014-05-31",
                "value": 178.73
            },
            {
                "date": "2014-06-30",
                "value": 176.69
            },
            {
                "date": "2014-07-31",
                "value": 179.16
            },
            {
                "date": "2014-08-31",
                "value": 181.53
            },
            {
                "date": "2014-09-30",
                "value": 180.07
            },
            {
                "date": "2014-10-31",
                "value": 182.14
            },
            {
                "date": "2014-11-30",
                "value": 186.48
            },
            {
                "date": "2014-12-31",
                "value": 184.47
            },
            {
                "date": "2015-01-31",
                "value": 186.52
            },
            {
                "date": "2015-02-28",
                "value": 187.19
            },
            {
                "date": "2015-03-31",
                "value": 196.33
            },
            {
                "date": "2015-04-30",
                "value": 189.7
            },
            {
                "date": "2015-05-31",
                "value": 193
            },
            {
                "date": "2015-06-30",
                "value": 192.5
            },
            {
                "date": "2015-07-31",
                "value": 192.78
            },
            {
                "date": "2015-08-31",
                "value": 200.79
            },
            {
                "date": "2015-09-30",
                "value": 201.46
            },
            {
                "date": "2015-10-31",
                "value": 211.19
            },
            {
                "date": "2015-11-30",
                "value": 210.07
            },
            {
                "date": "2015-12-31",
                "value": 212.27
            },
            {
                "date": "2016-01-31",
                "value": 210.93
            },
            {
                "date": "2016-02-29",
                "value": 208.76
            },
            {
                "date": "2016-03-31",
                "value": 209.75
            },
            {
                "date": "2016-04-30",
                "value": 209.3
            },
            {
                "date": "2016-05-31",
                "value": 210.88
            },
            {
                "date": "2016-06-30",
                "value": 202.74
            },
            {
                "date": "2016-07-31",
                "value": 211.57
            },
            {
                "date": "2016-08-31",
                "value": 211.6
            },
            {
                "date": "2016-09-30",
                "value": 219.72
            },
            {
                "date": "2016-10-31",
                "value": 216.06
            },
            {
                "date": "2016-11-30",
                "value": 218.08
            },
            {
                "date": "2016-12-31",
                "value": 232.65
            },
            {
                "date": "2017-01-31",
                "value": 229.42
            },
            {
                "date": "2017-02-28",
                "value": 223.36
            },
            {
                "date": "2017-03-31",
                "value": 221.7
            },
            {
                "date": "2017-04-30",
                "value": 224.57
            },
            {
                "date": "2017-05-31",
                "value": 228.47
            },
            {
                "date": "2017-06-30",
                "value": 235.16
            },
            {
                "date": "2017-07-31",
                "value": 234.78
            },
            {
                "date": "2017-08-31",
                "value": 228.08
            },
            {
                "date": "2017-09-30",
                "value": 226.89
            },
            {
                "date": "2017-10-31",
                "value": 233.31
            },
            {
                "date": "2017-11-30",
                "value": 236.3
            },
            {
                "date": "2017-12-31",
                "value": 227.88
            },
            {
                "date": "2018-01-31",
                "value": 228.52
            },
            {
                "date": "2018-02-28",
                "value": 235.71
            },
            {
                "date": "2018-03-31",
                "value": 246.56
            },
            {
                "date": "2018-04-30",
                "value": 250.19
            },
            {
                "date": "2018-05-31",
                "value": 252.61
            },
            {
                "date": "2018-06-30",
                "value": 247.23
            },
            {
                "date": "2018-07-31",
                "value": 243.93
            },
            {
                "date": "2018-08-31",
                "value": 245.01
            },
            {
                "date": "2018-09-30",
                "value": 248.33
            },
            {
                "date": "2018-10-31",
                "value": 252.09
            },
            {
                "date": "2018-11-30",
                "value": 250.56
            },
            {
                "date": "2018-12-31",
                "value": 245.66
            },
            {
                "date": "2019-01-31",
                "value": 242.7
            },
            {
                "date": "2019-02-28",
                "value": 237.93
            },
            {
                "date": "2019-03-31",
                "value": 241.83
            },
            {
                "date": "2019-04-30",
                "value": 231.49
            },
            {
                "date": "2019-05-31",
                "value": 230.76
            },
            {
                "date": "2019-06-30",
                "value": 233.64
            },
            {
                "date": "2019-07-31",
                "value": 241.57
            },
            {
                "date": "2019-08-31",
                "value": 242.76
            },
            {
                "date": "2019-09-30",
                "value": 248.47
            },
            {
                "date": "2019-10-31",
                "value": 247.36
            },
            {
                "date": "2019-11-30",
                "value": 244.54
            },
            {
                "date": "2019-12-31",
                "value": 242.1
            },
            {
                "date": "2020-01-31",
                "value": 248.47
            },
            {
                "date": "2020-02-29",
                "value": 262.73
            },
            {
                "date": "2020-03-31",
                "value": 261.53
            },
            {
                "date": "2020-04-30",
                "value": 257.26
            },
            {
                "date": "2020-05-31",
                "value": 269.7
            },
            {
                "date": "2020-06-30",
                "value": 257.44
            },
            {
                "date": "2020-07-31",
                "value": 258.87
            },
            {
                "date": "2020-08-31",
                "value": 237.69
            },
            {
                "date": "2020-09-30",
                "value": 226.63
            },
            {
                "date": "2020-10-31",
                "value": 224.11
            },
            {
                "date": "2020-11-30",
                "value": 212.33
            },
            {
                "date": "2020-12-31",
                "value": 204.49
            },
            {
                "date": "2021-01-31",
                "value": 206.55
            },
            {
                "date": "2021-02-28",
                "value": 208.8
            },
            {
                "date": "2021-03-31",
                "value": 213.68
            },
            {
                "date": "2021-04-30",
                "value": 217.8
            },
            {
                "date": "2021-05-31",
                "value": 217.74
            },
            {
                "date": "2021-06-30",
                "value": 224.37
            },
            {
                "date": "2021-07-31",
                "value": 224.55
            },
            {
                "date": "2021-08-31",
                "value": 222.37
            },
            {
                "date": "2021-09-30",
                "value": 220.83
            },
            {
                "date": "2021-10-31",
                "value": 219.02
            },
            {
                "date": "2021-11-30",
                "value": 210.3
            },
            {
                "date": "2021-12-31",
                "value": 211.69
            },
            {
                "date": "2022-01-31",
                "value": 213.49
            },
            {
                "date": "2022-02-28",
                "value": 212.69
            },
            {
                "date": "2022-03-31",
                "value": 210.4
            },
            {
                "date": "2022-04-30",
                "value": 212.7
            },
            {
                "date": "2022-05-31",
                "value": 220.75
            },
            {
                "date": "2022-06-30",
                "value": 221.69
            },
            {
                "date": "2022-07-31",
                "value": 220.21
            },
            {
                "date": "2022-08-31",
                "value": 218.38
            },
            {
                "date": "2022-09-30",
                "value": 218.84
            },
            {
                "date": "2022-10-31",
                "value": 214.07
            },
            {
                "date": "2022-11-30",
                "value": 214.28
            },
            {
                "date": "2022-12-31",
                "value": 215.3
            },
            {
                "date": "2023-01-31",
                "value": 223.99
            },
            {
                "date": "2023-02-28",
                "value": 229
            },
            {
                "date": "2023-03-31",
                "value": 234.54
            },
            {
                "date": "2023-04-30",
                "value": 232.02
            },
            {
                "date": "2023-05-31",
                "value": 235.94
            },
            {
                "date": "2023-06-30",
                "value": 231.39
            },
            {
                "date": "2023-07-31",
                "value": 233.64
            },
            {
                "date": "2023-08-31",
                "value": 236.42
            },
            {
                "date": "2023-09-30",
                "value": 233.62
            },
            {
                "date": "2023-10-31",
                "value": 243.78
            },
            {
                "date": "2023-11-30",
                "value": 247.4
            },
            {
                "date": "2023-12-31",
                "value": 238.85
            },
            {
                "date": "2024-01-31",
                "value": 242.33
            },
            {
                "date": "2024-02-29",
                "value": 241.2
            },
            {
                "date": "2024-03-31",
                "value": 242.05
            },
            {
                "date": "2024-04-30",
                "value": 245.15
            },
            {
                "date": "2024-05-31",
                "value": 247.93
            },
            {
                "date": "2024-06-30",
                "value": 238.68
            },
            {
                "date": "2024-07-31",
                "value": 233.99
            },
            {
                "date": "2024-08-31",
                "value": 238.42
            },
            {
                "date": "2024-09-30",
                "value": 245.46
            },
            {
                "date": "2024-10-31",
                "value": 255.66
            },
            {
                "date": "2024-11-30",
                "value": 265.78
            },
            {
                "date": "2024-12-31",
                "value": 255.78
            }
        ],
        "frequency": "monthly",
        "active": true
    },
    {
        "id": "emergmkt",
        "name": "iShares MSCI Emerging Markets UCITS ETF",
        "assetClass": "Equities",
        "quotationCurrency": "CHF",
        "timeSeries": [
            {
                "date": "2005-01-31",
                "value": 40.43
            },
            {
                "date": "2005-02-28",
                "value": 43.2
            },
            {
                "date": "2005-03-31",
                "value": 41.45
            },
            {
                "date": "2005-04-30",
                "value": 43.75
            },
            {
                "date": "2005-05-31",
                "value": 43.45
            },
            {
                "date": "2005-06-30",
                "value": 43.14
            },
            {
                "date": "2005-07-31",
                "value": 47.5
            },
            {
                "date": "2005-08-31",
                "value": 48.16
            },
            {
                "date": "2005-09-30",
                "value": 48.34
            },
            {
                "date": "2005-10-31",
                "value": 50.39
            },
            {
                "date": "2005-11-30",
                "value": 53.54
            },
            {
                "date": "2005-12-31",
                "value": 53.77
            },
            {
                "date": "2006-01-31",
                "value": 55.68
            },
            {
                "date": "2006-02-28",
                "value": 53.3
            },
            {
                "date": "2006-03-31",
                "value": 52.64
            },
            {
                "date": "2006-04-30",
                "value": 51.81
            },
            {
                "date": "2006-05-31",
                "value": 48.67
            },
            {
                "date": "2006-06-30",
                "value": 45.29
            },
            {
                "date": "2006-07-31",
                "value": 41.88
            },
            {
                "date": "2006-08-31",
                "value": 41.63
            },
            {
                "date": "2006-09-30",
                "value": 41.52
            },
            {
                "date": "2006-10-31",
                "value": 41.1
            },
            {
                "date": "2006-11-30",
                "value": 41.49
            },
            {
                "date": "2006-12-31",
                "value": 38.97
            },
            {
                "date": "2007-01-31",
                "value": 39.05
            },
            {
                "date": "2007-02-28",
                "value": 39.75
            },
            {
                "date": "2007-03-31",
                "value": 41.48
            },
            {
                "date": "2007-04-30",
                "value": 39.97
            },
            {
                "date": "2007-05-31",
                "value": 39.41
            },
            {
                "date": "2007-06-30",
                "value": 35.68
            },
            {
                "date": "2007-07-31",
                "value": 34.99
            },
            {
                "date": "2007-08-31",
                "value": 31.36
            },
            {
                "date": "2007-09-30",
                "value": 29.32
            },
            {
                "date": "2007-10-31",
                "value": 31.11
            },
            {
                "date": "2007-11-30",
                "value": 27.88
            },
            {
                "date": "2007-12-31",
                "value": 29.16
            },
            {
                "date": "2008-01-31",
                "value": 29.81
            },
            {
                "date": "2008-02-29",
                "value": 29.52
            },
            {
                "date": "2008-03-31",
                "value": 30.38
            },
            {
                "date": "2008-04-30",
                "value": 31.36
            },
            {
                "date": "2008-05-31",
                "value": 33.19
            },
            {
                "date": "2008-06-30",
                "value": 33
            },
            {
                "date": "2008-07-31",
                "value": 32.23
            },
            {
                "date": "2008-08-31",
                "value": 31.44
            },
            {
                "date": "2008-09-30",
                "value": 30.08
            },
            {
                "date": "2008-10-31",
                "value": 30.19
            },
            {
                "date": "2008-11-30",
                "value": 29.19
            },
            {
                "date": "2008-12-31",
                "value": 30.92
            },
            {
                "date": "2009-01-31",
                "value": 28.22
            },
            {
                "date": "2009-02-28",
                "value": 26.85
            },
            {
                "date": "2009-03-31",
                "value": 25.73
            },
            {
                "date": "2009-04-30",
                "value": 23.19
            },
            {
                "date": "2009-05-31",
                "value": 25.53
            },
            {
                "date": "2009-06-30",
                "value": 22.61
            },
            {
                "date": "2009-07-31",
                "value": 22.43
            },
            {
                "date": "2009-08-31",
                "value": 21.97
            },
            {
                "date": "2009-09-30",
                "value": 23.92
            },
            {
                "date": "2009-10-31",
                "value": 21.69
            },
            {
                "date": "2009-11-30",
                "value": 22.99
            },
            {
                "date": "2009-12-31",
                "value": 22.28
            },
            {
                "date": "2010-01-31",
                "value": 22.24
            },
            {
                "date": "2010-02-28",
                "value": 21.63
            },
            {
                "date": "2010-03-31",
                "value": 22.45
            },
            {
                "date": "2010-04-30",
                "value": 21.31
            },
            {
                "date": "2010-05-31",
                "value": 21.36
            },
            {
                "date": "2010-06-30",
                "value": 21.86
            },
            {
                "date": "2010-07-31",
                "value": 24
            },
            {
                "date": "2010-08-31",
                "value": 21.26
            },
            {
                "date": "2010-09-30",
                "value": 23.01
            },
            {
                "date": "2010-10-31",
                "value": 24.24
            },
            {
                "date": "2010-11-30",
                "value": 23.8
            },
            {
                "date": "2010-12-31",
                "value": 24.3
            },
            {
                "date": "2011-01-31",
                "value": 23.88
            },
            {
                "date": "2011-02-28",
                "value": 25.99
            },
            {
                "date": "2011-03-31",
                "value": 26.42
            },
            {
                "date": "2011-04-30",
                "value": 26.29
            },
            {
                "date": "2011-05-31",
                "value": 26.15
            },
            {
                "date": "2011-06-30",
                "value": 26.05
            },
            {
                "date": "2011-07-31",
                "value": 25.97
            },
            {
                "date": "2011-08-31",
                "value": 24.99
            },
            {
                "date": "2011-09-30",
                "value": 27.71
            },
            {
                "date": "2011-10-31",
                "value": 25.23
            },
            {
                "date": "2011-11-30",
                "value": 20.83
            },
            {
                "date": "2011-12-31",
                "value": 20.83
            },
            {
                "date": "2012-01-31",
                "value": 20.8
            },
            {
                "date": "2012-02-29",
                "value": 21.31
            },
            {
                "date": "2012-03-31",
                "value": 21.22
            },
            {
                "date": "2012-04-30",
                "value": 21.19
            },
            {
                "date": "2012-05-31",
                "value": 21.67
            },
            {
                "date": "2012-06-30",
                "value": 22.85
            },
            {
                "date": "2012-07-31",
                "value": 22.48
            },
            {
                "date": "2012-08-31",
                "value": 22.19
            },
            {
                "date": "2012-09-30",
                "value": 24.48
            },
            {
                "date": "2012-10-31",
                "value": 25.28
            },
            {
                "date": "2012-11-30",
                "value": 24.18
            },
            {
                "date": "2012-12-31",
                "value": 27.14
            },
            {
                "date": "2013-01-31",
                "value": 28.35
            },
            {
                "date": "2013-02-28",
                "value": 27.69
            },
            {
                "date": "2013-03-31",
                "value": 26.23
            },
            {
                "date": "2013-04-30",
                "value": 26.78
            },
            {
                "date": "2013-05-31",
                "value": 25.82
            },
            {
                "date": "2013-06-30",
                "value": 24.61
            },
            {
                "date": "2013-07-31",
                "value": 23.16
            },
            {
                "date": "2013-08-31",
                "value": 22.72
            },
            {
                "date": "2013-09-30",
                "value": 24.11
            },
            {
                "date": "2013-10-31",
                "value": 23.73
            },
            {
                "date": "2013-11-30",
                "value": 22.16
            },
            {
                "date": "2013-12-31",
                "value": 23.03
            },
            {
                "date": "2014-01-31",
                "value": 23.24
            },
            {
                "date": "2014-02-28",
                "value": 24.36
            },
            {
                "date": "2014-03-31",
                "value": 25.97
            },
            {
                "date": "2014-04-30",
                "value": 25.91
            },
            {
                "date": "2014-05-31",
                "value": 25.88
            },
            {
                "date": "2014-06-30",
                "value": 25.98
            },
            {
                "date": "2014-07-31",
                "value": 24.66
            },
            {
                "date": "2014-08-31",
                "value": 25.63
            },
            {
                "date": "2014-09-30",
                "value": 27.54
            },
            {
                "date": "2014-10-31",
                "value": 27.95
            },
            {
                "date": "2014-11-30",
                "value": 27.78
            },
            {
                "date": "2014-12-31",
                "value": 27.59
            },
            {
                "date": "2015-01-31",
                "value": 26.68
            },
            {
                "date": "2015-02-28",
                "value": 25.77
            },
            {
                "date": "2015-03-31",
                "value": 25.4
            },
            {
                "date": "2015-04-30",
                "value": 24.49
            },
            {
                "date": "2015-05-31",
                "value": 24.1
            },
            {
                "date": "2015-06-30",
                "value": 22.34
            },
            {
                "date": "2015-07-31",
                "value": 22.87
            },
            {
                "date": "2015-08-31",
                "value": 23.06
            },
            {
                "date": "2015-09-30",
                "value": 21.87
            },
            {
                "date": "2015-10-31",
                "value": 19.49
            },
            {
                "date": "2015-11-30",
                "value": 19.6
            },
            {
                "date": "2015-12-31",
                "value": 20.8
            },
            {
                "date": "2016-01-31",
                "value": 20.16
            },
            {
                "date": "2016-02-29",
                "value": 19.79
            },
            {
                "date": "2016-03-31",
                "value": 19.35
            },
            {
                "date": "2016-04-30",
                "value": 20.1
            },
            {
                "date": "2016-05-31",
                "value": 19.3
            },
            {
                "date": "2016-06-30",
                "value": 20.36
            },
            {
                "date": "2016-07-31",
                "value": 20.18
            },
            {
                "date": "2016-08-31",
                "value": 21.23
            },
            {
                "date": "2016-09-30",
                "value": 21.39
            },
            {
                "date": "2016-10-31",
                "value": 21.28
            },
            {
                "date": "2016-11-30",
                "value": 19.83
            },
            {
                "date": "2016-12-31",
                "value": 19.27
            },
            {
                "date": "2017-01-31",
                "value": 19.13
            },
            {
                "date": "2017-02-28",
                "value": 19.88
            },
            {
                "date": "2017-03-31",
                "value": 20.24
            },
            {
                "date": "2017-04-30",
                "value": 19.66
            },
            {
                "date": "2017-05-31",
                "value": 20.18
            },
            {
                "date": "2017-06-30",
                "value": 21.29
            },
            {
                "date": "2017-07-31",
                "value": 21.26
            },
            {
                "date": "2017-08-31",
                "value": 20.92
            },
            {
                "date": "2017-09-30",
                "value": 20.64
            },
            {
                "date": "2017-10-31",
                "value": 21.6
            },
            {
                "date": "2017-11-30",
                "value": 22.31
            },
            {
                "date": "2017-12-31",
                "value": 21.41
            },
            {
                "date": "2018-01-31",
                "value": 21.94
            },
            {
                "date": "2018-02-28",
                "value": 21.54
            },
            {
                "date": "2018-03-31",
                "value": 20.86
            },
            {
                "date": "2018-04-30",
                "value": 22.28
            },
            {
                "date": "2018-05-31",
                "value": 23.33
            },
            {
                "date": "2018-06-30",
                "value": 22.62
            },
            {
                "date": "2018-07-31",
                "value": 22.85
            },
            {
                "date": "2018-08-31",
                "value": 23.56
            },
            {
                "date": "2018-09-30",
                "value": 22.95
            },
            {
                "date": "2018-10-31",
                "value": 22.95
            },
            {
                "date": "2018-11-30",
                "value": 23.85
            },
            {
                "date": "2018-12-31",
                "value": 21.86
            },
            {
                "date": "2019-01-31",
                "value": 22.35
            },
            {
                "date": "2019-02-28",
                "value": 23.31
            },
            {
                "date": "2019-03-31",
                "value": 24.03
            },
            {
                "date": "2019-04-30",
                "value": 22.57
            },
            {
                "date": "2019-05-31",
                "value": 23.06
            },
            {
                "date": "2019-06-30",
                "value": 22.2
            },
            {
                "date": "2019-07-31",
                "value": 22.97
            },
            {
                "date": "2019-08-31",
                "value": 23.8
            },
            {
                "date": "2019-09-30",
                "value": 24.2
            },
            {
                "date": "2019-10-31",
                "value": 23.42
            },
            {
                "date": "2019-11-30",
                "value": 22.87
            },
            {
                "date": "2019-12-31",
                "value": 23.98
            },
            {
                "date": "2020-01-31",
                "value": 23.05
            },
            {
                "date": "2020-02-29",
                "value": 23.76
            },
            {
                "date": "2020-03-31",
                "value": 24.51
            },
            {
                "date": "2020-04-30",
                "value": 24.32
            },
            {
                "date": "2020-05-31",
                "value": 27.37
            },
            {
                "date": "2020-06-30",
                "value": 27.63
            },
            {
                "date": "2020-07-31",
                "value": 30.76
            },
            {
                "date": "2020-08-31",
                "value": 27.85
            },
            {
                "date": "2020-09-30",
                "value": 24.89
            },
            {
                "date": "2020-10-31",
                "value": 26.26
            },
            {
                "date": "2020-11-30",
                "value": 27.25
            },
            {
                "date": "2020-12-31",
                "value": 26.99
            },
            {
                "date": "2021-01-31",
                "value": 27.08
            },
            {
                "date": "2021-02-28",
                "value": 24.67
            },
            {
                "date": "2021-03-31",
                "value": 24.04
            },
            {
                "date": "2021-04-30",
                "value": 22.94
            },
            {
                "date": "2021-05-31",
                "value": 22.83
            },
            {
                "date": "2021-06-30",
                "value": 23.97
            },
            {
                "date": "2021-07-31",
                "value": 24.18
            },
            {
                "date": "2021-08-31",
                "value": 24.78
            },
            {
                "date": "2021-09-30",
                "value": 24.06
            },
            {
                "date": "2021-10-31",
                "value": 23.68
            },
            {
                "date": "2021-11-30",
                "value": 23.95
            },
            {
                "date": "2021-12-31",
                "value": 23.76
            },
            {
                "date": "2022-01-31",
                "value": 25.41
            },
            {
                "date": "2022-02-28",
                "value": 24.45
            },
            {
                "date": "2022-03-31",
                "value": 26.9
            },
            {
                "date": "2022-04-30",
                "value": 25.75
            },
            {
                "date": "2022-05-31",
                "value": 27.26
            },
            {
                "date": "2022-06-30",
                "value": 26.37
            },
            {
                "date": "2022-07-31",
                "value": 28.71
            },
            {
                "date": "2022-08-31",
                "value": 29.07
            },
            {
                "date": "2022-09-30",
                "value": 29.83
            },
            {
                "date": "2022-10-31",
                "value": 31.12
            },
            {
                "date": "2022-11-30",
                "value": 30.32
            },
            {
                "date": "2022-12-31",
                "value": 28.92
            },
            {
                "date": "2023-01-31",
                "value": 26.16
            },
            {
                "date": "2023-02-28",
                "value": 27.91
            },
            {
                "date": "2023-03-31",
                "value": 27.11
            },
            {
                "date": "2023-04-30",
                "value": 26.47
            },
            {
                "date": "2023-05-31",
                "value": 26.59
            },
            {
                "date": "2023-06-30",
                "value": 29.39
            },
            {
                "date": "2023-07-31",
                "value": 27.03
            },
            {
                "date": "2023-08-31",
                "value": 27.53
            },
            {
                "date": "2023-09-30",
                "value": 27.15
            },
            {
                "date": "2023-10-31",
                "value": 28.03
            },
            {
                "date": "2023-11-30",
                "value": 25.68
            },
            {
                "date": "2023-12-31",
                "value": 25.32
            },
            {
                "date": "2024-01-31",
                "value": 26.54
            },
            {
                "date": "2024-02-29",
                "value": 28.77
            },
            {
                "date": "2024-03-31",
                "value": 31.24
            },
            {
                "date": "2024-04-30",
                "value": 30.09
            },
            {
                "date": "2024-05-31",
                "value": 30.35
            },
            {
                "date": "2024-06-30",
                "value": 30.37
            },
            {
                "date": "2024-07-31",
                "value": 28.46
            },
            {
                "date": "2024-08-31",
                "value": 26.58
            },
            {
                "date": "2024-09-30",
                "value": 27.75
            },
            {
                "date": "2024-10-31",
                "value": 28.25
            },
            {
                "date": "2024-11-30",
                "value": 28.22
            },
            {
                "date": "2024-12-31",
                "value": 30.11
            }
        ],
        "frequency": "monthly",
        "active": true
    },
    {
        "id": "gold",
        "name": "iShares Physical Gold CHF Hedged ETC",
        "assetClass": "Commodities",
        "quotationCurrency": "CHF",
        "timeSeries": [
            {
                "date": "2005-01-31",
                "value": 130.55
            },
            {
                "date": "2005-02-28",
                "value": 132.76
            },
            {
                "date": "2005-03-31",
                "value": 131.32
            },
            {
                "date": "2005-04-30",
                "value": 133.11
            },
            {
                "date": "2005-05-31",
                "value": 137.21
            },
            {
                "date": "2005-06-30",
                "value": 139.31
            },
            {
                "date": "2005-07-31",
                "value": 146.26
            },
            {
                "date": "2005-08-31",
                "value": 142.81
            },
            {
                "date": "2005-09-30",
                "value": 143.53
            },
            {
                "date": "2005-10-31",
                "value": 140.92
            },
            {
                "date": "2005-11-30",
                "value": 138.03
            },
            {
                "date": "2005-12-31",
                "value": 137.69
            },
            {
                "date": "2006-01-31",
                "value": 139.01
            },
            {
                "date": "2006-02-28",
                "value": 141.18
            },
            {
                "date": "2006-03-31",
                "value": 143.75
            },
            {
                "date": "2006-04-30",
                "value": 153.82
            },
            {
                "date": "2006-05-31",
                "value": 158.26
            },
            {
                "date": "2006-06-30",
                "value": 151.16
            },
            {
                "date": "2006-07-31",
                "value": 152.54
            },
            {
                "date": "2006-08-31",
                "value": 150.15
            },
            {
                "date": "2006-09-30",
                "value": 148.28
            },
            {
                "date": "2006-10-31",
                "value": 154.53
            },
            {
                "date": "2006-11-30",
                "value": 153.96
            },
            {
                "date": "2006-12-31",
                "value": 145.41
            },
            {
                "date": "2007-01-31",
                "value": 147.2
            },
            {
                "date": "2007-02-28",
                "value": 146.36
            },
            {
                "date": "2007-03-31",
                "value": 141.64
            },
            {
                "date": "2007-04-30",
                "value": 138.15
            },
            {
                "date": "2007-05-31",
                "value": 135.97
            },
            {
                "date": "2007-06-30",
                "value": 136.29
            },
            {
                "date": "2007-07-31",
                "value": 134.95
            },
            {
                "date": "2007-08-31",
                "value": 135.64
            },
            {
                "date": "2007-09-30",
                "value": 143.52
            },
            {
                "date": "2007-10-31",
                "value": 140.51
            },
            {
                "date": "2007-11-30",
                "value": 137.53
            },
            {
                "date": "2007-12-31",
                "value": 136.91
            },
            {
                "date": "2008-01-31",
                "value": 141.82
            },
            {
                "date": "2008-02-29",
                "value": 139.24
            },
            {
                "date": "2008-03-31",
                "value": 145.65
            },
            {
                "date": "2008-04-30",
                "value": 140.37
            },
            {
                "date": "2008-05-31",
                "value": 136.45
            },
            {
                "date": "2008-06-30",
                "value": 136.63
            },
            {
                "date": "2008-07-31",
                "value": 133.5
            },
            {
                "date": "2008-08-31",
                "value": 131.43
            },
            {
                "date": "2008-09-30",
                "value": 133.6
            },
            {
                "date": "2008-10-31",
                "value": 136.9
            },
            {
                "date": "2008-11-30",
                "value": 137.78
            },
            {
                "date": "2008-12-31",
                "value": 137.06
            },
            {
                "date": "2009-01-31",
                "value": 143
            },
            {
                "date": "2009-02-28",
                "value": 145.16
            },
            {
                "date": "2009-03-31",
                "value": 144.57
            },
            {
                "date": "2009-04-30",
                "value": 150.27
            },
            {
                "date": "2009-05-31",
                "value": 146.65
            },
            {
                "date": "2009-06-30",
                "value": 147.82
            },
            {
                "date": "2009-07-31",
                "value": 151.19
            },
            {
                "date": "2009-08-31",
                "value": 151.59
            },
            {
                "date": "2009-09-30",
                "value": 149.43
            },
            {
                "date": "2009-10-31",
                "value": 151.45
            },
            {
                "date": "2009-11-30",
                "value": 149.45
            },
            {
                "date": "2009-12-31",
                "value": 147.23
            },
            {
                "date": "2010-01-31",
                "value": 143.15
            },
            {
                "date": "2010-02-28",
                "value": 149.19
            },
            {
                "date": "2010-03-31",
                "value": 147.17
            },
            {
                "date": "2010-04-30",
                "value": 152.71
            },
            {
                "date": "2010-05-31",
                "value": 154.92
            },
            {
                "date": "2010-06-30",
                "value": 154.17
            },
            {
                "date": "2010-07-31",
                "value": 157.72
            },
            {
                "date": "2010-08-31",
                "value": 159.48
            },
            {
                "date": "2010-09-30",
                "value": 160.59
            },
            {
                "date": "2010-10-31",
                "value": 154.44
            },
            {
                "date": "2010-11-30",
                "value": 155.23
            },
            {
                "date": "2010-12-31",
                "value": 159.86
            },
            {
                "date": "2011-01-31",
                "value": 162.68
            },
            {
                "date": "2011-02-28",
                "value": 168.02
            },
            {
                "date": "2011-03-31",
                "value": 176.04
            },
            {
                "date": "2011-04-30",
                "value": 178.74
            },
            {
                "date": "2011-05-31",
                "value": 189.86
            },
            {
                "date": "2011-06-30",
                "value": 181.81
            },
            {
                "date": "2011-07-31",
                "value": 181.04
            },
            {
                "date": "2011-08-31",
                "value": 167.88
            },
            {
                "date": "2011-09-30",
                "value": 172.51
            },
            {
                "date": "2011-10-31",
                "value": 173.52
            },
            {
                "date": "2011-11-30",
                "value": 182.83
            },
            {
                "date": "2011-12-31",
                "value": 181.37
            },
            {
                "date": "2012-01-31",
                "value": 170.89
            },
            {
                "date": "2012-02-29",
                "value": 177.95
            },
            {
                "date": "2012-03-31",
                "value": 171.32
            },
            {
                "date": "2012-04-30",
                "value": 165.32
            },
            {
                "date": "2012-05-31",
                "value": 164.95
            },
            {
                "date": "2012-06-30",
                "value": 168.55
            },
            {
                "date": "2012-07-31",
                "value": 166.48
            },
            {
                "date": "2012-08-31",
                "value": 167.91
            },
            {
                "date": "2012-09-30",
                "value": 158.94
            },
            {
                "date": "2012-10-31",
                "value": 167.67
            },
            {
                "date": "2012-11-30",
                "value": 167.83
            },
            {
                "date": "2012-12-31",
                "value": 168.94
            },
            {
                "date": "2013-01-31",
                "value": 172.41
            },
            {
                "date": "2013-02-28",
                "value": 173.81
            },
            {
                "date": "2013-03-31",
                "value": 175.37
            },
            {
                "date": "2013-04-30",
                "value": 171.01
            },
            {
                "date": "2013-05-31",
                "value": 170.95
            },
            {
                "date": "2013-06-30",
                "value": 173.7
            },
            {
                "date": "2013-07-31",
                "value": 179.66
            },
            {
                "date": "2013-08-31",
                "value": 179.55
            },
            {
                "date": "2013-09-30",
                "value": 180.58
            },
            {
                "date": "2013-10-31",
                "value": 182.95
            },
            {
                "date": "2013-11-30",
                "value": 186.64
            },
            {
                "date": "2013-12-31",
                "value": 188.36
            },
            {
                "date": "2014-01-31",
                "value": 187.5
            },
            {
                "date": "2014-02-28",
                "value": 185.19
            },
            {
                "date": "2014-03-31",
                "value": 191.99
            },
            {
                "date": "2014-04-30",
                "value": 194.26
            },
            {
                "date": "2014-05-31",
                "value": 194.96
            },
            {
                "date": "2014-06-30",
                "value": 215.89
            },
            {
                "date": "2014-07-31",
                "value": 222.26
            },
            {
                "date": "2014-08-31",
                "value": 228.61
            },
            {
                "date": "2014-09-30",
                "value": 230.34
            },
            {
                "date": "2014-10-31",
                "value": 224.02
            },
            {
                "date": "2014-11-30",
                "value": 232.33
            },
            {
                "date": "2014-12-31",
                "value": 232.41
            },
            {
                "date": "2015-01-31",
                "value": 233.48
            },
            {
                "date": "2015-02-28",
                "value": 241.37
            },
            {
                "date": "2015-03-31",
                "value": 249.47
            },
            {
                "date": "2015-04-30",
                "value": 252.01
            },
            {
                "date": "2015-05-31",
                "value": 252.91
            },
            {
                "date": "2015-06-30",
                "value": 269.58
            },
            {
                "date": "2015-07-31",
                "value": 275.03
            },
            {
                "date": "2015-08-31",
                "value": 267.39
            },
            {
                "date": "2015-09-30",
                "value": 274.21
            },
            {
                "date": "2015-10-31",
                "value": 276.28
            },
            {
                "date": "2015-11-30",
                "value": 277.38
            },
            {
                "date": "2015-12-31",
                "value": 283.89
            },
            {
                "date": "2016-01-31",
                "value": 286.74
            },
            {
                "date": "2016-02-29",
                "value": 304.85
            },
            {
                "date": "2016-03-31",
                "value": 307.63
            },
            {
                "date": "2016-04-30",
                "value": 310.88
            },
            {
                "date": "2016-05-31",
                "value": 322.64
            },
            {
                "date": "2016-06-30",
                "value": 318.15
            },
            {
                "date": "2016-07-31",
                "value": 328.78
            },
            {
                "date": "2016-08-31",
                "value": 329.18
            },
            {
                "date": "2016-09-30",
                "value": 341.85
            },
            {
                "date": "2016-10-31",
                "value": 334.17
            },
            {
                "date": "2016-11-30",
                "value": 339.38
            },
            {
                "date": "2016-12-31",
                "value": 324.12
            },
            {
                "date": "2017-01-31",
                "value": 320.8
            },
            {
                "date": "2017-02-28",
                "value": 321.92
            },
            {
                "date": "2017-03-31",
                "value": 327.66
            },
            {
                "date": "2017-04-30",
                "value": 348.04
            },
            {
                "date": "2017-05-31",
                "value": 368.27
            },
            {
                "date": "2017-06-30",
                "value": 354.58
            },
            {
                "date": "2017-07-31",
                "value": 347.59
            },
            {
                "date": "2017-08-31",
                "value": 361.69
            },
            {
                "date": "2017-09-30",
                "value": 367.53
            },
            {
                "date": "2017-10-31",
                "value": 353.58
            },
            {
                "date": "2017-11-30",
                "value": 359.79
            },
            {
                "date": "2017-12-31",
                "value": 348.73
            },
            {
                "date": "2018-01-31",
                "value": 340.8
            },
            {
                "date": "2018-02-28",
                "value": 328.97
            },
            {
                "date": "2018-03-31",
                "value": 327.39
            },
            {
                "date": "2018-04-30",
                "value": 350.46
            },
            {
                "date": "2018-05-31",
                "value": 355.49
            },
            {
                "date": "2018-06-30",
                "value": 355.42
            },
            {
                "date": "2018-07-31",
                "value": 383.28
            },
            {
                "date": "2018-08-31",
                "value": 379.12
            },
            {
                "date": "2018-09-30",
                "value": 378.57
            },
            {
                "date": "2018-10-31",
                "value": 376.72
            },
            {
                "date": "2018-11-30",
                "value": 382.61
            },
            {
                "date": "2018-12-31",
                "value": 380.2
            },
            {
                "date": "2019-01-31",
                "value": 397.93
            },
            {
                "date": "2019-02-28",
                "value": 395.64
            },
            {
                "date": "2019-03-31",
                "value": 403.5
            },
            {
                "date": "2019-04-30",
                "value": 407.43
            },
            {
                "date": "2019-05-31",
                "value": 398.17
            },
            {
                "date": "2019-06-30",
                "value": 387.73
            },
            {
                "date": "2019-07-31",
                "value": 388.3
            },
            {
                "date": "2019-08-31",
                "value": 362.79
            },
            {
                "date": "2019-09-30",
                "value": 364.05
            },
            {
                "date": "2019-10-31",
                "value": 366.01
            },
            {
                "date": "2019-11-30",
                "value": 368.68
            },
            {
                "date": "2019-12-31",
                "value": 368.95
            },
            {
                "date": "2020-01-31",
                "value": 373.97
            },
            {
                "date": "2020-02-29",
                "value": 371.19
            },
            {
                "date": "2020-03-31",
                "value": 379.46
            },
            {
                "date": "2020-04-30",
                "value": 362.09
            },
            {
                "date": "2020-05-31",
                "value": 373.06
            },
            {
                "date": "2020-06-30",
                "value": 364.36
            },
            {
                "date": "2020-07-31",
                "value": 370.76
            },
            {
                "date": "2020-08-31",
                "value": 366.71
            },
            {
                "date": "2020-09-30",
                "value": 363.15
            },
            {
                "date": "2020-10-31",
                "value": 355.64
            },
            {
                "date": "2020-11-30",
                "value": 371
            },
            {
                "date": "2020-12-31",
                "value": 360.05
            },
            {
                "date": "2021-01-31",
                "value": 348.14
            },
            {
                "date": "2021-02-28",
                "value": 351.45
            },
            {
                "date": "2021-03-31",
                "value": 355.25
            },
            {
                "date": "2021-04-30",
                "value": 356.78
            },
            {
                "date": "2021-05-31",
                "value": 347.57
            },
            {
                "date": "2021-06-30",
                "value": 341.86
            },
            {
                "date": "2021-07-31",
                "value": 352.15
            },
            {
                "date": "2021-08-31",
                "value": 342.34
            },
            {
                "date": "2021-09-30",
                "value": 349.64
            },
            {
                "date": "2021-10-31",
                "value": 358.31
            },
            {
                "date": "2021-11-30",
                "value": 360.82
            },
            {
                "date": "2021-12-31",
                "value": 348.82
            },
            {
                "date": "2022-01-31",
                "value": 369.77
            },
            {
                "date": "2022-02-28",
                "value": 372.28
            },
            {
                "date": "2022-03-31",
                "value": 375.61
            },
            {
                "date": "2022-04-30",
                "value": 372.53
            },
            {
                "date": "2022-05-31",
                "value": 363.11
            },
            {
                "date": "2022-06-30",
                "value": 361.32
            },
            {
                "date": "2022-07-31",
                "value": 364.59
            },
            {
                "date": "2022-08-31",
                "value": 356.5
            },
            {
                "date": "2022-09-30",
                "value": 358.83
            },
            {
                "date": "2022-10-31",
                "value": 372.27
            },
            {
                "date": "2022-11-30",
                "value": 378.27
            },
            {
                "date": "2022-12-31",
                "value": 378.34
            },
            {
                "date": "2023-01-31",
                "value": 391.37
            },
            {
                "date": "2023-02-28",
                "value": 403.31
            },
            {
                "date": "2023-03-31",
                "value": 415.42
            },
            {
                "date": "2023-04-30",
                "value": 406.81
            },
            {
                "date": "2023-05-31",
                "value": 385.97
            },
            {
                "date": "2023-06-30",
                "value": 396.35
            },
            {
                "date": "2023-07-31",
                "value": 398.28
            },
            {
                "date": "2023-08-31",
                "value": 395.09
            },
            {
                "date": "2023-09-30",
                "value": 402.02
            },
            {
                "date": "2023-10-31",
                "value": 397.83
            },
            {
                "date": "2023-11-30",
                "value": 391.69
            },
            {
                "date": "2023-12-31",
                "value": 414.03
            },
            {
                "date": "2024-01-31",
                "value": 395.63
            },
            {
                "date": "2024-02-29",
                "value": 406.76
            },
            {
                "date": "2024-03-31",
                "value": 420.31
            },
            {
                "date": "2024-04-30",
                "value": 443.87
            },
            {
                "date": "2024-05-31",
                "value": 448.58
            },
            {
                "date": "2024-06-30",
                "value": 456.77
            },
            {
                "date": "2024-07-31",
                "value": 445.69
            },
            {
                "date": "2024-08-31",
                "value": 447.47
            },
            {
                "date": "2024-09-30",
                "value": 420.74
            },
            {
                "date": "2024-10-31",
                "value": 414.9
            },
            {
                "date": "2024-11-30",
                "value": 415.82
            },
            {
                "date": "2024-12-31",
                "value": 415.79
            }
        ],
        "frequency": "monthly",
        "active": true
    },
    {
        "id": "MSCIWORLD_CHF",
        "name": "iShares MSCI World CHF Hedged UCITS ETF",
        "assetClass": "Equities",
        "quotationCurrency": "CHF",
        "frequency": "monthly",
        "active": true,
        "timeSeries": [
            {
                "date": "2005-01-31",
                "value": 54.93
            },
            {
                "date": "2005-02-28",
                "value": 53.74
            },
            {
                "date": "2005-03-31",
                "value": 54.86
            },
            {
                "date": "2005-04-30",
                "value": 55.46
            },
            {
                "date": "2005-05-31",
                "value": 57.59
            },
            {
                "date": "2005-06-30",
                "value": 54.65
            },
            {
                "date": "2005-07-31",
                "value": 54.01
            },
            {
                "date": "2005-08-31",
                "value": 52.66
            },
            {
                "date": "2005-09-30",
                "value": 50.66
            },
            {
                "date": "2005-10-31",
                "value": 49.2
            },
            {
                "date": "2005-11-30",
                "value": 48.44
            },
            {
                "date": "2005-12-31",
                "value": 48.13
            },
            {
                "date": "2006-01-31",
                "value": 46.62
            },
            {
                "date": "2006-02-28",
                "value": 47.64
            },
            {
                "date": "2006-03-31",
                "value": 46.84
            },
            {
                "date": "2006-04-30",
                "value": 41.08
            },
            {
                "date": "2006-05-31",
                "value": 43.24
            },
            {
                "date": "2006-06-30",
                "value": 42.78
            },
            {
                "date": "2006-07-31",
                "value": 41.72
            },
            {
                "date": "2006-08-31",
                "value": 42.38
            },
            {
                "date": "2006-09-30",
                "value": 42.98
            },
            {
                "date": "2006-10-31",
                "value": 43.29
            },
            {
                "date": "2006-11-30",
                "value": 42.02
            },
            {
                "date": "2006-12-31",
                "value": 42.55
            },
            {
                "date": "2007-01-31",
                "value": 40.15
            },
            {
                "date": "2007-02-28",
                "value": 42.67
            },
            {
                "date": "2007-03-31",
                "value": 40.72
            },
            {
                "date": "2007-04-30",
                "value": 40.59
            },
            {
                "date": "2007-05-31",
                "value": 40.82
            },
            {
                "date": "2007-06-30",
                "value": 41.39
            },
            {
                "date": "2007-07-31",
                "value": 41.18
            },
            {
                "date": "2007-08-31",
                "value": 42.19
            },
            {
                "date": "2007-09-30",
                "value": 36.26
            },
            {
                "date": "2007-10-31",
                "value": 36.11
            },
            {
                "date": "2007-11-30",
                "value": 35.87
            },
            {
                "date": "2007-12-31",
                "value": 35.24
            },
            {
                "date": "2008-01-31",
                "value": 37.39
            },
            {
                "date": "2008-02-29",
                "value": 35.92
            },
            {
                "date": "2008-03-31",
                "value": 35.79
            },
            {
                "date": "2008-04-30",
                "value": 32.87
            },
            {
                "date": "2008-05-31",
                "value": 33.22
            },
            {
                "date": "2008-06-30",
                "value": 31.05
            },
            {
                "date": "2008-07-31",
                "value": 29.08
            },
            {
                "date": "2008-08-31",
                "value": 31.83
            },
            {
                "date": "2008-09-30",
                "value": 32.72
            },
            {
                "date": "2008-10-31",
                "value": 32.7
            },
            {
                "date": "2008-11-30",
                "value": 32.92
            },
            {
                "date": "2008-12-31",
                "value": 31
            },
            {
                "date": "2009-01-31",
                "value": 29.67
            },
            {
                "date": "2009-02-28",
                "value": 30.17
            },
            {
                "date": "2009-03-31",
                "value": 27.58
            },
            {
                "date": "2009-04-30",
                "value": 27.88
            },
            {
                "date": "2009-05-31",
                "value": 25.91
            },
            {
                "date": "2009-06-30",
                "value": 26.03
            },
            {
                "date": "2009-07-31",
                "value": 24.85
            },
            {
                "date": "2009-08-31",
                "value": 26.61
            },
            {
                "date": "2009-09-30",
                "value": 27.7
            },
            {
                "date": "2009-10-31",
                "value": 27.11
            },
            {
                "date": "2009-11-30",
                "value": 25.03
            },
            {
                "date": "2009-12-31",
                "value": 24.22
            },
            {
                "date": "2010-01-31",
                "value": 24.16
            },
            {
                "date": "2010-02-28",
                "value": 23.18
            },
            {
                "date": "2010-03-31",
                "value": 23.44
            },
            {
                "date": "2010-04-30",
                "value": 24.38
            },
            {
                "date": "2010-05-31",
                "value": 24.31
            },
            {
                "date": "2010-06-30",
                "value": 23.88
            },
            {
                "date": "2010-07-31",
                "value": 24.63
            },
            {
                "date": "2010-08-31",
                "value": 24.33
            },
            {
                "date": "2010-09-30",
                "value": 25.16
            },
            {
                "date": "2010-10-31",
                "value": 24.83
            },
            {
                "date": "2010-11-30",
                "value": 26.45
            },
            {
                "date": "2010-12-31",
                "value": 26.15
            },
            {
                "date": "2011-01-31",
                "value": 25.01
            },
            {
                "date": "2011-02-28",
                "value": 25.11
            },
            {
                "date": "2011-03-31",
                "value": 24.46
            },
            {
                "date": "2011-04-30",
                "value": 23.52
            },
            {
                "date": "2011-05-31",
                "value": 23.39
            },
            {
                "date": "2011-06-30",
                "value": 24.1
            },
            {
                "date": "2011-07-31",
                "value": 21.98
            },
            {
                "date": "2011-08-31",
                "value": 21.93
            },
            {
                "date": "2011-09-30",
                "value": 21.8
            },
            {
                "date": "2011-10-31",
                "value": 21.66
            },
            {
                "date": "2011-11-30",
                "value": 22.37
            },
            {
                "date": "2011-12-31",
                "value": 21.18
            },
            {
                "date": "2012-01-31",
                "value": 21.75
            },
            {
                "date": "2012-02-29",
                "value": 21.54
            },
            {
                "date": "2012-03-31",
                "value": 21.64
            },
            {
                "date": "2012-04-30",
                "value": 21.45
            },
            {
                "date": "2012-05-31",
                "value": 21.16
            },
            {
                "date": "2012-06-30",
                "value": 20.72
            },
            {
                "date": "2012-07-31",
                "value": 21.07
            },
            {
                "date": "2012-08-31",
                "value": 22.87
            },
            {
                "date": "2012-09-30",
                "value": 23.86
            },
            {
                "date": "2012-10-31",
                "value": 24.7
            },
            {
                "date": "2012-11-30",
                "value": 25.27
            },
            {
                "date": "2012-12-31",
                "value": 24.8
            },
            {
                "date": "2013-01-31",
                "value": 25.42
            },
            {
                "date": "2013-02-28",
                "value": 27.58
            },
            {
                "date": "2013-03-31",
                "value": 26.17
            },
            {
                "date": "2013-04-30",
                "value": 27.08
            },
            {
                "date": "2013-05-31",
                "value": 28.22
            },
            {
                "date": "2013-06-30",
                "value": 28.57
            },
            {
                "date": "2013-07-31",
                "value": 29.52
            },
            {
                "date": "2013-08-31",
                "value": 31.22
            },
            {
                "date": "2013-09-30",
                "value": 34.07
            },
            {
                "date": "2013-10-31",
                "value": 35.93
            },
            {
                "date": "2013-11-30",
                "value": 38.41
            },
            {
                "date": "2013-12-31",
                "value": 38.99
            },
            {
                "date": "2014-01-31",
                "value": 40.37
            },
            {
                "date": "2014-02-28",
                "value": 40.74
            },
            {
                "date": "2014-03-31",
                "value": 41.31
            },
            {
                "date": "2014-04-30",
                "value": 40.63
            },
            {
                "date": "2014-05-31",
                "value": 41.84
            },
            {
                "date": "2014-06-30",
                "value": 44.4
            },
            {
                "date": "2014-07-31",
                "value": 44.22
            },
            {
                "date": "2014-08-31",
                "value": 44.79
            },
            {
                "date": "2014-09-30",
                "value": 46.04
            },
            {
                "date": "2014-10-31",
                "value": 46.2
            },
            {
                "date": "2014-11-30",
                "value": 48.09
            },
            {
                "date": "2014-12-31",
                "value": 48.73
            },
            {
                "date": "2015-01-31",
                "value": 46.57
            },
            {
                "date": "2015-02-28",
                "value": 44.77
            },
            {
                "date": "2015-03-31",
                "value": 46.22
            },
            {
                "date": "2015-04-30",
                "value": 47.55
            },
            {
                "date": "2015-05-31",
                "value": 49.82
            },
            {
                "date": "2015-06-30",
                "value": 50.49
            },
            {
                "date": "2015-07-31",
                "value": 51.07
            },
            {
                "date": "2015-08-31",
                "value": 47.99
            },
            {
                "date": "2015-09-30",
                "value": 50.86
            },
            {
                "date": "2015-10-31",
                "value": 49.14
            },
            {
                "date": "2015-11-30",
                "value": 51.38
            },
            {
                "date": "2015-12-31",
                "value": 49.2
            },
            {
                "date": "2016-01-31",
                "value": 48.06
            },
            {
                "date": "2016-02-29",
                "value": 48.53
            },
            {
                "date": "2016-03-31",
                "value": 47.87
            },
            {
                "date": "2016-04-30",
                "value": 46.7
            },
            {
                "date": "2016-05-31",
                "value": 48.56
            },
            {
                "date": "2016-06-30",
                "value": 50.07
            },
            {
                "date": "2016-07-31",
                "value": 51.06
            },
            {
                "date": "2016-08-31",
                "value": 50.56
            },
            {
                "date": "2016-09-30",
                "value": 49.08
            },
            {
                "date": "2016-10-31",
                "value": 48.32
            },
            {
                "date": "2016-11-30",
                "value": 47.49
            },
            {
                "date": "2016-12-31",
                "value": 47.63
            },
            {
                "date": "2017-01-31",
                "value": 49.3
            },
            {
                "date": "2017-02-28",
                "value": 49.16
            },
            {
                "date": "2017-03-31",
                "value": 47.79
            },
            {
                "date": "2017-04-30",
                "value": 46.8
            },
            {
                "date": "2017-05-31",
                "value": 49.41
            },
            {
                "date": "2017-06-30",
                "value": 49.94
            },
            {
                "date": "2017-07-31",
                "value": 50.63
            },
            {
                "date": "2017-08-31",
                "value": 51.42
            },
            {
                "date": "2017-09-30",
                "value": 52.86
            },
            {
                "date": "2017-10-31",
                "value": 53.39
            },
            {
                "date": "2017-11-30",
                "value": 56.16
            },
            {
                "date": "2017-12-31",
                "value": 58.24
            },
            {
                "date": "2018-01-31",
                "value": 51.87
            },
            {
                "date": "2018-02-28",
                "value": 51.82
            },
            {
                "date": "2018-03-31",
                "value": 58.21
            },
            {
                "date": "2018-04-30",
                "value": 55.48
            },
            {
                "date": "2018-05-31",
                "value": 56.02
            },
            {
                "date": "2018-06-30",
                "value": 58.71
            },
            {
                "date": "2018-07-31",
                "value": 58.99
            },
            {
                "date": "2018-08-31",
                "value": 62.44
            },
            {
                "date": "2018-09-30",
                "value": 59.57
            },
            {
                "date": "2018-10-31",
                "value": 56.86
            },
            {
                "date": "2018-11-30",
                "value": 56.7
            },
            {
                "date": "2018-12-31",
                "value": 55.3
            },
            {
                "date": "2019-01-31",
                "value": 53.18
            },
            {
                "date": "2019-02-28",
                "value": 54.65
            },
            {
                "date": "2019-03-31",
                "value": 55.51
            },
            {
                "date": "2019-04-30",
                "value": 55.81
            },
            {
                "date": "2019-05-31",
                "value": 55.18
            },
            {
                "date": "2019-06-30",
                "value": 56.04
            },
            {
                "date": "2019-07-31",
                "value": 56.04
            },
            {
                "date": "2019-08-31",
                "value": 54.68
            },
            {
                "date": "2019-09-30",
                "value": 56.08
            },
            {
                "date": "2019-10-31",
                "value": 57.19
            },
            {
                "date": "2019-11-30",
                "value": 57.66
            },
            {
                "date": "2019-12-31",
                "value": 59.55
            },
            {
                "date": "2020-01-31",
                "value": 57.21
            },
            {
                "date": "2020-02-29",
                "value": 57.17
            },
            {
                "date": "2020-03-31",
                "value": 56.25
            },
            {
                "date": "2020-04-30",
                "value": 59.53
            },
            {
                "date": "2020-05-31",
                "value": 61.04
            },
            {
                "date": "2020-06-30",
                "value": 66.52
            },
            {
                "date": "2020-07-31",
                "value": 71.03
            },
            {
                "date": "2020-08-31",
                "value": 70.33
            },
            {
                "date": "2020-09-30",
                "value": 67.61
            },
            {
                "date": "2020-10-31",
                "value": 69.25
            },
            {
                "date": "2020-11-30",
                "value": 68.82
            },
            {
                "date": "2020-12-31",
                "value": 68.72
            },
            {
                "date": "2021-01-31",
                "value": 66.15
            },
            {
                "date": "2021-02-28",
                "value": 68.07
            },
            {
                "date": "2021-03-31",
                "value": 68.92
            },
            {
                "date": "2021-04-30",
                "value": 70.37
            },
            {
                "date": "2021-05-31",
                "value": 71.6
            },
            {
                "date": "2021-06-30",
                "value": 69.37
            },
            {
                "date": "2021-07-31",
                "value": 63.5
            },
            {
                "date": "2021-08-31",
                "value": 63.13
            },
            {
                "date": "2021-09-30",
                "value": 61.84
            },
            {
                "date": "2021-10-31",
                "value": 60.84
            },
            {
                "date": "2021-11-30",
                "value": 63.48
            },
            {
                "date": "2021-12-31",
                "value": 63.54
            },
            {
                "date": "2022-01-31",
                "value": 67.7
            },
            {
                "date": "2022-02-28",
                "value": 68.53
            },
            {
                "date": "2022-03-31",
                "value": 70.76
            },
            {
                "date": "2022-04-30",
                "value": 72.55
            },
            {
                "date": "2022-05-31",
                "value": 75.25
            },
            {
                "date": "2022-06-30",
                "value": 71.84
            },
            {
                "date": "2022-07-31",
                "value": 75.33
            },
            {
                "date": "2022-08-31",
                "value": 76.03
            },
            {
                "date": "2022-09-30",
                "value": 73.44
            },
            {
                "date": "2022-10-31",
                "value": 75.61
            },
            {
                "date": "2022-11-30",
                "value": 77.04
            },
            {
                "date": "2022-12-31",
                "value": 81.39
            },
            {
                "date": "2023-01-31",
                "value": 84.18
            },
            {
                "date": "2023-02-28",
                "value": 85.83
            },
            {
                "date": "2023-03-31",
                "value": 80.65
            },
            {
                "date": "2023-04-30",
                "value": 86.46
            },
            {
                "date": "2023-05-31",
                "value": 92.04
            },
            {
                "date": "2023-06-30",
                "value": 95.36
            },
            {
                "date": "2023-07-31",
                "value": 97.59
            },
            {
                "date": "2023-08-31",
                "value": 102.83
            },
            {
                "date": "2023-09-30",
                "value": 99.78
            },
            {
                "date": "2023-10-31",
                "value": 103.08
            },
            {
                "date": "2023-11-30",
                "value": 103.69
            },
            {
                "date": "2023-12-31",
                "value": 100.05
            },
            {
                "date": "2024-01-31",
                "value": 102.02
            },
            {
                "date": "2024-02-29",
                "value": 103.97
            },
            {
                "date": "2024-03-31",
                "value": 111.58
            },
            {
                "date": "2024-04-30",
                "value": 116.35
            },
            {
                "date": "2024-05-31",
                "value": 109.47
            },
            {
                "date": "2024-06-30",
                "value": 101.42
            },
            {
                "date": "2024-07-31",
                "value": 101.61
            },
            {
                "date": "2024-08-31",
                "value": 101.27
            },
            {
                "date": "2024-09-30",
                "value": 97.98
            },
            {
                "date": "2024-10-31",
                "value": 92.76
            },
            {
                "date": "2024-11-30",
                "value": 92.5
            },
            {
                "date": "2024-12-31",
                "value": 88.68
            }
        ]
    }
];
